'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { PropTypes } from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';

const TrialCta = ({
  agency,
  onClick
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: "cta-section",
    children: [/*#__PURE__*/_jsx("div", {
      className: "cta-title",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "widgetResults.CTA.title"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "cta-microcopy",
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "widgetResults.CTA.description",
        options: {
          agency
        }
      })
    }), /*#__PURE__*/_jsx("a", {
      className: "button white",
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: onClick,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "widgetResults.CTA.button",
        options: {
          agency
        }
      })
    })]
  });
};

TrialCta.propTypes = {
  agency: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
export default TrialCta;